export default function Hero() {
  const handleCTAClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[520px] md:min-h-[640px] flex items-center bg-background-50 overflow-hidden pt-16"
    >
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          {/* Left: Text Content */}
          <div className="flex-1 w-full text-center lg:text-left pt-8 md:pt-12 lg:pt-0">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs md:text-sm font-medium mb-4 md:mb-5 whitespace-nowrap">
              水果植物系列 · 热门影视聚合
            </span>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-[3.25rem] leading-tight text-foreground-950 mb-3 md:mb-4">
              妖精视频
              <span className="block text-2xl sm:text-3xl md:text-4xl lg:text-[2.5rem] text-foreground-700 mt-1">
                水果植物系列视频聚合平台
              </span>
            </h1>

            <p className="text-base md:text-lg text-primary-500 font-medium mb-5 md:mb-6">
              香蕉视频 · 蜜桃视频 · 西瓜视频 · 樱花视频 一站尽览
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6 md:mb-7">
              妖精视频专注水果植物系列影视聚合，每日同步更新香蕉视频、蜜桃视频、西瓜视频、樱花视频等热门平台最新内容。
              高清画质流畅播放，电视剧全集不缓冲，最新电影大全一网打尽，为您打造极致的在线观影体验。
            </p>

            {/* Status Badges */}
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 md:gap-4 mb-7 md:mb-8">
              <div className="flex items-center gap-2 px-3 py-2 rounded-lg bg-accent-50 text-accent-700 text-xs md:text-sm">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                每日同步更新
              </div>
              <div className="flex items-center gap-2 px-3 py-2 rounded-lg bg-secondary-50 text-secondary-700 text-xs md:text-sm">
                <i className="ri-vidicon-line text-sm"></i>
                覆盖 7 大热门平台
              </div>
              <div className="flex items-center gap-2 px-3 py-2 rounded-lg bg-background-100 text-foreground-600 text-xs md:text-sm">
                <i className="ri-shield-check-line text-sm"></i>
                高清流畅不缓冲
              </div>
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#topics"
                onClick={(e) => handleCTAClick(e, '#topics')}
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm md:text-base hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                探索热门话题
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleCTAClick(e, '#ranking')}
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full border-2 border-background-200 text-foreground-700 font-medium text-sm md:text-base hover:border-primary-300 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                查看热度榜单
                <i className="ri-fire-line"></i>
              </a>
            </div>
          </div>

          {/* Right: Main Visual */}
          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20artistic%20digital%20illustration%20featuring%20abstract%20fruit%20silhouettes%20including%20banana%20peach%20watermelon%20and%20cherry%20blossom%20blended%20with%20film%20reel%20elements%20play%20button%20icons%20and%20streaming%20visual%20motifs%2C%20warm%20coral%20and%20soft%20green%20color%20palette%20on%20light%20cream%20background%2C%20smooth%20gradient%20transitions%2C%20clean%20minimalist%20design%2C%20editorial%20quality%2C%202D%20flat%20vector%20style%20with%20subtle%20texture&width=960&height=720&seq=hero-visual-01&orientation=landscape"
                alt="妖精视频水果植物系列影视聚合平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}